// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CreateBasicHydroDataInput } from "./CreateBasicHydroDataInput";
import {
  CreateBasicHydroDataInputFromJSON,
  CreateBasicHydroDataInputFromJSONTyped,
  CreateBasicHydroDataInputToJSON,
  CreateBasicHydroDataInputToJSONTyped,
} from "./CreateBasicHydroDataInput";
import type { CreateBasicHydroDataOutput } from "./CreateBasicHydroDataOutput";
import {
  CreateBasicHydroDataOutputFromJSON,
  CreateBasicHydroDataOutputFromJSONTyped,
  CreateBasicHydroDataOutputToJSON,
  CreateBasicHydroDataOutputToJSONTyped,
} from "./CreateBasicHydroDataOutput";

/**
 *
 * @export
 * @interface CreateBasicHydroDataSchema
 */
export interface CreateBasicHydroDataSchema {
  /**
   *
   */
  tag: CreateBasicHydroDataSchemaTagEnum;
  /**
   *
   */
  inputs: CreateBasicHydroDataInput;
  /**
   *
   */
  outputs: CreateBasicHydroDataOutput;
}

/**
 * @export
 */
export const CreateBasicHydroDataSchemaTagEnum = {
  CreateBasicHydroData: "create_basic_hydro_data",
} as const;
export type CreateBasicHydroDataSchemaTagEnum =
  (typeof CreateBasicHydroDataSchemaTagEnum)[keyof typeof CreateBasicHydroDataSchemaTagEnum];

/**
 * Check if a given object implements the CreateBasicHydroDataSchema interface.
 */
export function instanceOfCreateBasicHydroDataSchema(
  value: object
): value is CreateBasicHydroDataSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "create_basic_hydro_data") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function CreateBasicHydroDataSchemaFromJSON(json: any): CreateBasicHydroDataSchema {
  return CreateBasicHydroDataSchemaFromJSONTyped(json, false);
}

export function CreateBasicHydroDataSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateBasicHydroDataSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: CreateBasicHydroDataInputFromJSON(json["inputs"]),
    outputs: CreateBasicHydroDataOutputFromJSON(json["outputs"]),
  };
}

export function CreateBasicHydroDataSchemaToJSON(json: any): CreateBasicHydroDataSchema {
  return CreateBasicHydroDataSchemaToJSONTyped(json, false);
}

export function CreateBasicHydroDataSchemaToJSONTyped(
  value?: CreateBasicHydroDataSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: CreateBasicHydroDataInputToJSON(value["inputs"]),
    outputs: CreateBasicHydroDataOutputToJSON(value["outputs"]),
  };
}
